import { render, staticRenderFns } from "./BasePicture.vue?vue&type=template&id=f52a6d3a&scoped=true&"
import script from "./BasePicture.vue?vue&type=script&lang=js&"
export * from "./BasePicture.vue?vue&type=script&lang=js&"
import style0 from "./BasePicture.vue?vue&type=style&index=0&id=f52a6d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_e0fc12eb4d0f55f4cb07c19882e21395/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52a6d3a",
  null
  
)

export default component.exports